import { LangKey, Langs } from '../intl';

export default class PreferencesService {
  langKey = 'lang';

  getLang(): LangKey | null {
    const key = localStorage.getItem(this.langKey);
    if (!Langs.includes(key as LangKey)) {
      const browserLang = window.navigator.language.slice(0, 2);
      if (!Langs.includes(browserLang as LangKey)) return 'en';
    }
    return key as LangKey;
  }

  setLang(key: LangKey): void {
    localStorage.setItem(this.langKey, key);
  }
}
